import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useRecordWebcam } from 'react-record-webcam'
import VideocamIcon from "@material-ui/icons/Videocam";
import { colors } from "../layout/constants";
import { sendVideo, sendImageAnswer } from "../../services/test";

let videoStream;
let mediaRecorder,
    statusQuestion,
    triedSend = false,
    question, image;

const VideoTest = ({ setHasVideo, setVideoError, user, activeQuestion, setAllowCamera, setAskedAllowCamera, statusSendQuestion, questionsLength, stopVideo, setStopVideo, sendVideoBool, setSendVideo, startedNewQuestion }) => {
    statusQuestion = statusSendQuestion;
    question = activeQuestion;
    const [loadingCamera, setLoadingCamera] = useState(false);
    const [isReadyToRecord, setIsReadyToRecord] = useState(true);
    const [fakeCamera, setFakeCamera] = useState(false);
    const recordWebcam = useRecordWebcam({ 
        frameRate: 60,
        mimeType: 'video/webm;codecs=vp9'
    });
    const canvasRef = useRef(null);
    const divCameraRef = useRef(null);

    //cliclo
    //open camara
    //start recording
    //stop recording

    useEffect(() => {
        recordWebcam.open();
    }, []);

    useEffect(() => {
        console.log(recordWebcam?.status)
        checkPermissions();
        if (recordWebcam?.status === 'OPEN') {
            recordWebcam.start();
        }
        
        if (recordWebcam?.status === 'PREVIEW') {
            //setHasVideo(false);
            setLoadingCamera(true);
            sendQuestionVideo();

            if(questionsLength !== 0){
                setTimeout(() => {
                    setStopVideo(false);
                    recordWebcam.open();
                }, 300);   
            }
        }
        if (recordWebcam?.status === 'RECORDING') {
            //setHasVideo(true);
            setVideoError("");
            setAskedAllowCamera(true);
            setAllowCamera(true);
            setLoadingCamera(false);
            // take image
            if (canvasRef.current) {
                const ctx = canvasRef.current.getContext("2d");
                ctx.drawImage(recordWebcam.webcamRef.current, 115, 80, 115, 80);
                image = canvasRef.current.toDataURL("image/jpg");
            }
        }
    }, [recordWebcam?.status]);

    useEffect(() => {
        if(stopVideo){
            recordWebcam.stop();
        }
    },[stopVideo])

    useEffect(() => {
        if(startedNewQuestion){
            setHasVideo(true);
        }else{
            setHasVideo(false);
        }
    },[startedNewQuestion]);

    /*useEffect(() => {
        if (statusQuestion === 2 && !triedSend || statusQuestion === 3 && !triedSend) {
            recordWebcam.stop();
        }

        if (statusQuestion === 0 && triedSend) {
            //setFakeCamera(false);
            triedSend = false;
            recordWebcam.open();
        }
    }, [statusQuestion]);*/

    const checkPermissions = () => {
        navigator.permissions.query({ name: "camera" }).then(res => {
            if (res.state == "granted") {
                navigator.permissions.query({ name: "microphone" }).then(resaudio => {
                    if (resaudio.state == "granted") {
                        //setCheckedVideo(true);
                        //setAskedAllowCamera(true);
                        //setAllowCamera(true);
                    }else{
                        //setLoading(true);
                        setHasVideo(false);
                        setVideoError("Microfono desactivado");
                        setAskedAllowCamera(true);
                    }
                });
            }else{
                //setLoading(true);
                setHasVideo(false);
                setVideoError("Camara desactivada");
                setAskedAllowCamera(true);
            }
        });
    }

    const sendQuestionVideo = async () => {
        triedSend = true;
        const blob = await recordWebcam.getRecording();
        if (statusQuestion === 2) {
            //setSendVideo(false)
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = (event) => {
                if (question) {
                    const base64data = reader.result.replace(";codecs=vp9,opus", "");
                    sendImageAnswer(user.token, {
                        question_id: question.id,
                        image: image
                    });
                    sendVideo(user.token, {
                        question_id: question.id,
                        video: base64data
                    });
                }
            };
            //setFakeCamera(true);
            //recordWebcam.open();
        }
    };

    return (
        <div>
            <VideoStyled ref={divCameraRef}>
                <video ref={recordWebcam.webcamRef} autoPlay muted
                    style={{
                        borderRadius: 4,
                        backgroundColor: 'rgb(0, 0, 0, 0.2)',
                        display: 'flex',
                        justifyContent: 'center',
                        height: 80,
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: 115,
                        zIndex: 5,
                        opacity: loadingCamera ? 0 : 1
                    }}
                />
                <canvas ref={canvasRef} className="canvas" ></canvas>
                <video ref={recordWebcam.previewRef} autoPlay muted loop
                    style={{
                        borderRadius: 4,
                        backgroundColor: 'rgb(0, 0, 0, 0.2)',
                        display: 'flex',
                        justifyContent: 'center',
                        height: 80,
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: 115,
                        zIndex: 5,
                        opacity: 0
                    }}
                />
                {loadingCamera && 
                    <div className="video-loading">
                        <VideocamIcon />
                    </div>
                }
            </VideoStyled>
        </div>
    )
}

const VideoStyled = styled.article`
	overflow: hidden;
	/* border: 1px solid gray; */
	border-radius: 4px;

	.video-loading {
		align-items: center;
		background-color: rgb(0, 0, 0, 0.2);
		border-radius: 4px;
		color: ${colors.primary};
		cursor: pointer;
		display: flex;
		height: 150px;
		justify-content: center;
		position: fixed;
		bottom: 10px;
		right: 10px;
		width: 200px;
		z-index: 5;

		:hover {
			color: ${colors.primaryLight};
		}
	}

	.MuiSvgIcon-root {
		font-size: 2em;
	}

	.video-player {
		border-radius: 4px;
		background-color: rgb(0, 0, 0, 0.2);
		display: flex;
		justify-content: center;
		height: 80px;
		position: fixed;
		top: 0px;
		right: 0px;
		width: 115px;
		z-index: 5;
	}

	.canvas {
		display: none;
	}

	@media (max-width: 460px) {
		top: 1em;
		right: 0;
		position: absolute;
		height: 115px;
		width: 150px;

		.video-player {
			width: 150px;
		}

		height: 115px;
		width: 150px;
	}
`;

export default VideoTest;